import { render } from "./AboutPowerTalent.vue?vue&type=template&id=28773d41&ts=true"
import script from "./AboutPowerTalent.vue?vue&type=script&lang=ts"
export * from "./AboutPowerTalent.vue?vue&type=script&lang=ts"

import "./AboutPowerTalent.vue?vue&type=style&index=0&id=28773d41&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__